import Keycloak from 'keycloak-js';

import { keycloakConfigOrigin } from './config';
import { client } from '@hey-api/client-fetch';

// -1 is required to force a refresh
// Otherwise - it will use the old token if it thinks it's still valid within a certain window of time
const TOKEN_VALIDITY_TIME = -1;
const TOKEN_REFRESH_INTERVAL = 45;

// A simple wrapper around the Keycloak SDK that automatically refreshes the token every so
// often and provides an Authorization header for services that need to be authed.
const keycloakService = (() => {
  let keycloakToken = null;

  const keycloak = new Keycloak(`${keycloakConfigOrigin}/keycloak/keycloak.json`);

  const handleTokenUpdate = () => {
    keycloakToken = keycloak.token;
    client.interceptors.request.use((request, _options) => {
      request.headers.set('Authorization', `Bearer ${keycloakToken}`);
      return request;
    });
  }

  keycloak.onTokenExpired = () => {
    keycloak.updateToken(TOKEN_VALIDITY_TIME).then(handleTokenUpdate);
  }

  // The Keycloak tokens expire after 60 seconds, so we'll refresh them every 45.
  setInterval(() => {
    keycloak.updateToken(TOKEN_VALIDITY_TIME).then(handleTokenUpdate);
  }, TOKEN_REFRESH_INTERVAL * 1000);

  return {
    keycloak,
    checkSSO: () =>
      new Promise(resolve => {
        keycloak.init({ onLoad: 'check-sso' }).then(isAuthenticated => {
          if (isAuthenticated) {
            handleTokenUpdate();
          }

          resolve(isAuthenticated);
        });
      }),
    hasAdminPrivileges: () => keycloak.hasRealmRole('admin'),
    getToken: () => keycloakToken,
    getAuthHeader: () => (keycloakToken ? `Bearer ${keycloakToken}` : ''),
  };
})();
export default keycloakService;
